import { useSeo } from "@/hooks/useSeo";
import { Reveal, Eyebrow, PageHero } from "@/components/Reveal";
import CTABand from "@/components/CTABand";

const segments = [
  {
    title: "Regulated enterprise",
    body: "Financial institutions, healthcare systems, insurers, and energy companies are deploying AI inside processes that are already regulated. They need independent evidence that those systems are reliable and compliant, in a form their auditors and regulators will accept.",
  },
  {
    title: "Standards bodies and regulators",
    body: "The organizations writing the rules for AI need infrastructure to evaluate against. Reform Intelligence provides the independent measurement and methodology that governance frameworks depend on to be enforceable.",
  },
  {
    title: "Government and defense",
    body: "Agencies and contractors deploying AI in national-security and mission-critical settings require evaluation at a standard the stakes demand. Reform Intelligence brings independent rigor to systems where failure is not an option.",
  },
  {
    title: "AI developers and deployers",
    body: "Model providers and platform companies increasingly need third-party evaluation to substantiate the claims they make. Independent evidence is more credible than self-certification, and the market is beginning to require it.",
  },
];

export default function WhoWeServe() {
  useSeo(
    "Who We Serve | Reform Intelligence®",
    "Reform Intelligence serves regulated enterprises, standards bodies and regulators, government and defense, and the AI developers who need independent evidence."
  );

  return (
    <>
      <PageHero
        eyebrow="Who we serve"
        headline="Built for the institutions that cannot afford to be wrong about AI."
        subhead="Four groups rely on independent evaluation and governance infrastructure. We serve all four."
      />

      <section data-testid="segments-section" className="bg-white">
        <div className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-24">
          <div className="space-y-0 divide-y divide-[#E4E7EC] border-y border-[#E4E7EC]">
            {segments.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.06}>
                <div data-testid={`segment-block-${i}`} className="grid grid-cols-1 gap-4 py-10 sm:grid-cols-[1fr_1.6fr] sm:gap-12">
                  <h3 className="font-serif2 text-2xl font-semibold text-[#1F2D4E]">
                    <span className="mr-4 text-sm font-semibold text-[#B08D3F]">0{i + 1}</span>
                    {s.title}
                  </h3>
                  <p className="leading-relaxed text-[#5A6B8C]">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand line="Not sure where you fit? Start a conversation." />
    </>
  );
}
